import { useFetch } from "./Fetching";
import { PERMISSIONS, PERMISSIONS_EDIT } from "../enums/QueryKeys";

export function useGetSingleUserPermissions(userId) {
  const url = "/users/permissions/";
  const {
    data: res,
    error,
    isLoading: loading,
  } = useFetch(url, userId, PERMISSIONS_EDIT + userId);

  const data = {
    user: res?.user,
    permissions: res?.permissions,
  };

  return { data, loading, error };
}
